import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAllBlogPosts } from '../lib/blogPosts';
import usePageMeta from '../hooks/usePageMeta';
import useHotjar from '../hooks/useHotjar';
import '../styles/blog.css';

function formatPublishedDate(dateString) {
  return new Date(dateString).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

function Blog() {
  usePageMeta({
    title: 'Blog',
    description: 'Practical notes from Risqly on vendor risk, security posture, and ecosystem resilience.',
  });
  useHotjar();

  const posts = getAllBlogPosts();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="blog-root">
      <Header />
      <main className="blog-main">
        <section className="blog-hero">
          <h1>Risqly Cybersecurity Blog</h1>
          <p>
            Practical notes on vendor risk, security posture, and ecosystem resilience. New posts are
            intentionally structured to stay fast to publish and easy to maintain.
          </p>
        </section>

        <section className="blog-list" aria-label="Blog posts">
          {posts.map((post) => (
            <article className="blog-card" key={post.slug}>
              <Link to={`/blog/${post.slug}`} className="blog-card-image-link" aria-label={`Read ${post.title}`}>
                <img src={post.heroImage} alt={post.heroImageAlt} className="blog-card-image" loading="lazy" />
              </Link>

              <div className="blog-card-content">
                <p className="blog-card-meta">
                  <span>{formatPublishedDate(post.publishedAt)}</span>
                  <span aria-hidden="true">•</span>
                  <span>{post.readTimeMinutes} min read</span>
                </p>
                <h2>
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-tags">
                  {post.tags.map((tag) => (
                    <span key={`${post.slug}-${tag}`} className="blog-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Blog;
